import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class RefreshHomeService {
  private refreshHomeSubject = new BehaviorSubject<void>(undefined);

  refreshHome$ = this.refreshHomeSubject.asObservable();

  refreshHome(): void {
    this.refreshHomeSubject.next();
  }
}
